import { Decoder } from 'jsonous';

import { resourceDecoder } from '../../../../../../Resource/Decoders';
import { stringOptionsDecoder } from '../../../../../Options/Decoders';
import { FilterOptionsResource } from './Types';

export const filterOptionsResourceDecoder: Decoder<FilterOptionsResource> =
  resourceDecoder(stringOptionsDecoder);
